var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoResultados01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1167",
    className: "st0",
    d: "M0.6,8h34.8v16c0,0-7-4-18.2,1S0.6,27.3,0.6,27.3V8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoResultados01);
export default __webpack_public_path__ + "static/media/ico-resultados-01.7d6411b47fbc2ca8a1a2d6f5896fceee.svg";
export { ForwardRef as ReactComponent };